module.exports = __webpack_public_path__ + "static/media/4 beach scene paradise sunset ocean muscle car.1055x1430.6e8d69b2.webp";